<template>
    <b-modal
        id="edit-text-block-modal"
        v-model="modal"
        :title="$t('lesson.edit_text_block')"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        @ok="save"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal edit-text-block-modal"
        size="xl">
        <b-alert
            v-if="errorsFound"
            variant="danger"
            show>
            {{ $t('common.not_all_required_fields_are_filled') }}
        </b-alert>
        <b-form-group
            class="block-type"
            :label="$t('common.type')"
            label-for="type-input">
            <b-form-select
                id="type-input"
                v-model="type"
                :options="blockTypes"></b-form-select>
        </b-form-group>

        <b-form-group
            class="text-block-title"
            label-for="text-block-title-input"
            :label="$t('common.title') + ':'">
            <template #label> {{ $t('common.title') }}: <span class="required">*</span></template>
            <b-form-input
                id="text-block-title-input"
                v-model="title"
                :placeholder="$t('common.title')">
            </b-form-input>
        </b-form-group>

        <div class="description" v-if="type !== 'title-only'">
            <b-form-group
                label="Omschrijving"
                label-for="description-input">
                <template #label> {{ $t('common.description') }}: <span class="required">*</span></template>
                <ckeditor
                    id="description-input"
                    v-model="description"
                    :editor="editor"
                    :placeholder="$t('common.description')"
                    :config="editorConfig">
                </ckeditor>
            </b-form-group>
        </div>
        <b-form-group
            class="time"
            label-for="time-input"
            :label="$t('lesson.duration_in_minutes') + ':'">
            <b-form-input
                id="time-input"
                v-model="duration"
                type="number"
                min="0">
            </b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
    import ApprenticeEditor from '../../../../../../helpers/ApprenticeEditor';
    import $ from 'jquery';

    export default {
        name: 'design-2021-lesson-manual-edit-text-block-modal',
        props: {
            lessonIn: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                modal: false,
                textBlock: null,
                title: '',
                description: '',
                duration: 0,
                editor: ApprenticeEditor,
                editorConfig: {
                    contentsCss: 'test',
                    bodyClass: 'mybodyclass',
                    toolbar: {
                        items: [
                            'heading',
                            'fontBackgroundColor',
                            '|',
                            'bold',
                            'italic',
                            'underline',
                            '|',
                            'bulletedList',
                            'numberedList',
                            'blockQuote',
                            '|',
                            'undo',
                            'redo',
                            'link'
                        ]
                    },
                    language: this.$authUser.locale,
                    table: {
                        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
                    }
                },
                type: 'standard',
                blockTypes: [
                    { value: 'standard', text: this.$t('lesson.types.standard') },
                    { value: 'background', text: this.$t('lesson.types.background_info') },
                    { value: 'extra', text: this.$t('lesson.types.extra_lesson_idea') },
                    { value: 'title-only', text: this.$t('lesson.types.title_only') },
                    { value: 'learning-activity', text: this.$t('lesson.types.learning_activity') }
                ],
                errorsFound: false
            };
        },
        methods: {
            show(textBlock) {
                this.title = textBlock.title;
                this.description = textBlock.description === null ? '' : textBlock.description;
                this.duration = textBlock.duration;
                this.type = textBlock.type;
                this.textBlock = textBlock;
                this.modal = true;
                this.errorsFound = false;
            },

            save(bvModal) {
                if (this.formHaveErrors()) {
                    bvModal.preventDefault();
                    $('.edit-text-block-modal').animate({ scrollTop: 0 }, 500);
                    return;
                }

                let data = {
                    title: this.title,
                    description: this.description,
                    duration: this.duration,
                    type: this.type,
                };
                this.alert.saving();

                this.axios.post(this.routes.updateLessonTextBlock(this.lessonIn.id, this.textBlock.id), data).then(
                    (response) => {
                        this.$emit('lesson-updated', response.data);
                    },
                    (error) => {
                        this.alert.ajaxError;
                    }
                );
            },


            formHaveErrors() {
                this.errorsFound = false;
                if (
                    (this.title === '' && this.type === 'title-only') ||
                    this.description === '' && this.title === ''
                ) {
                    this.errorsFound = true;
                }

                return this.errorsFound;
            }
        }
    };
</script>

<style scoped lang="scss"></style>
